export default __webpack_public_path__ + "static/media/Sharon_Babineau_AHV_In_Moms_We_Trust.04768694.jpg";